import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

    public loginLabel: string = 'Volver a login';
    public loginUrl  : string = '/login';

    constructor() { }

    ngOnInit() { }

}
